import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const CataloghiSectionSettings = (settingsProps) => {
  const themeOpts = [
    { label: 'Bianco', value: 'white' },
    { label: 'Grigio chiaro', value: 'neutral10' },
    { label: 'Grigio', value: 'neutral20' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          options={themeOpts}
          label="Sfondo"
          defaultValue={defaultProps['theme']}
        />
      </ToolbarSection>
      <LayoutToolbarSection defaultProps={defaultProps} initOpen />
    </>
  )
}

export const CataloghiSectionFloatingSettings = () =>
  React.createElement(CataloghiSectionSettings, { floating: true })
